import { isAndWebView, isIOSWebView } from './constants';

/**
 * @name 토스트 팝업 노출
 * @param message 완료 후 표시할 토스트 메시지 없으면 ""
 */
export const bridgeSetToastPopup = message => {
  try {
    if (isIOSWebView) {
      window.webkit.messageHandlers.toast.postMessage({
        message: message,
      });
    } else if (isAndWebView) {
      window.binder?.toast(message);
    } else {
      alert(message);
    }
  } catch (e) {
    console.log('error bridge setClipBoard');
  }
};

/**
 * 외부화면 이동
 * @param url 이동할 경로
 */
export const bridgeOpenBrowser = (url: string): void => {
  try {
    if (isIOSWebView) {
      webkit.messageHandlers.openBrowser.postMessage({
        url: url,
      });
    } else if (isAndWebView) {
      window.binder?.openBrowser(url);
    } else {
      window.open(url);
    }
  } catch (e) {
    console.log('error bridge openBrowser');
  }
};

/**
 * @name SMS 보내기
 */
export const bridgeSendSms = (message: string): void => {
  try {
    if (isIOSWebView) {
      webkit.messageHandlers.sendSms.postMessage({
        message: message,
      });
    } else if (isAndWebView) {
      window.binder?.sendSms(message);
    } else return;
  } catch (e) {
    console.log('error bridge SendSms');
  }
};
